import $ from "jquery";
import Vue from "vue";
import * as ers from "../../../errorsmessages/errors";
import * as suc from "../../../successmessages/success";
import * as rt from "../../../routes/routes";
import * as ses from "../../../configurations/session/sessioncomplete";
import authservice from "../../../configurations/authentications/auth";
import baseurl from "../../../configurations/baseurl/baseurl";
import router from "../../../router/index";

export const actions = {
  newConsignee({ commit }) {
    let consigneeDetails = {
      consignee_name: $(".consignee_name").val(),
      phone_number: $(".phone_number").val()
    };
    $(".creatingConsignee").hide();
    $(".creatingConsigneeLoader").show();
    baseurl.post(rt.newConsignee, consigneeDetails).then(res => {
      $(".creatingConsignee").show();
      $(".creatingConsigneeLoader").hide();

      if (res.data.code === 200) {
        window.$("#new-consignee").modal("hide");
        suc.consigneeCreateSuccess();
        commit("STORE_CONSIGNEES", res.data.consignees);
      } else if (res.data.code === 402) {
        ers.validateErrors();
      } else if (res.data.code === 403) {
        window.$("#new-consignee").modal("hide");
        ers.consigneeExists();
      } else if (res.data.code === 404) {
        ers.errorCreatingConsignee();
      } else if (res.data.code === 405) {
        window.$("#new-consignee").modal("hide");
        ers.noPermissionToCreate();
      } else if (res.data.code === 506) {
        window.$("#new-consignee").modal("hide");
        ses.sessionComplete();
      }
    });
  },
  loadConsignees({ commit }) {
    baseurl.get(rt.loadConsignees).then(res => {
      $(".consigneesLoader").hide();

      if (res.data.code === 200) {
        commit("STORE_CONSIGNEES", res.data.consignees);
      } else if (res.data.code === 404) {
        ers.errorLoadingConsignee();
      } else if (res.data.code === 405) {
        ers.noPermissionToRead();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        ses.sessionComplete();
      }
    });
  },
  viewConsignee({ commit }, consigneeId) {
    commit("STORE_CONSIGNEE_UPDATE", consigneeId);
    window.$("#update-consignee").modal("show");
  },
  viewConsignes({ commit }, consigneeId) {
    commit("STORE_CONSIGNEE_UPDATE", consigneeId);
  },

  viewConsignees({ commit }, consigneeId) {
    commit("STORE_CONSIGNEE_UPDATE", consigneeId);
    router.push("/addtrip");
  },
  consigneeUpdate({ commit }) {
    let consigneeDetails = {
      id: $(".id").val(),
      consignee_name: $(".Uconsignee_name").val(),
      phone_number: $(".Uphone_number").val()
    };
    $(".updatingConsignee").hide();
    $(".updatingConsigneeLoader").show();
    baseurl.post(rt.consigneeUpdate, consigneeDetails).then(res => {
      $(".updatingConsignee").show();
      $(".updatingConsigneeLoader").hide();

      if (res.data.code === 200) {
        window.$("#update-consignee").modal("hide");
        suc.consigneeUpdateSuccess();
        commit("STORE_CONSIGNEES", res.data.consignees);
      } else if (res.data.code === 402) {
        ers.validateErrors();
      } else if (res.data.code === 404) {
        ers.errorUpdatingConsignee();
        window.$("#update-consignee").modal("hide");
      } else if (res.data.code === 405) {
        window.$("#update-consignee").modal("hide");
        ers.noPermissionToUpdate();
      } else if (res.data.code === 506) {
        window.$("#update-consignee").modal("hide");
        ses.sessionComplete();
      }
    });
  }
};
export default actions;



// WEBPACK FOOTER //
// ./src/vuex/modules/consignees/actions.js